import _ from 'lodash'
import { ENTRIES_LOADED } from '../constants';

const initialState = {byContentfulId: {}, all:[]};

export default function update(state = initialState, action) {
    switch (action.type) {
        case ENTRIES_LOADED:
            if(action.entries.userRequest) {
                const result = initialState;
                Object.keys(action.entries.userRequest).map(key => {
                    result.byContentfulId[key] = action.entries.userRequest[key];
                    result.all.push(action.entries.userRequest[key]);
                })
                return result
            }
            break;
    }
    return state;
}
